var map = {
	"./brand-assets/files/png/jindo-logotype-stacked.png": "62c5",
	"./brand-assets/files/png/jindo-logotype.png": "95b6",
	"./brand-assets/files/png/jindo-symbol.png": "cb0a",
	"./brand-assets/jindo-logotype-stacked.svg": "4c5d",
	"./brand-assets/jindo-logotype.svg": "705e",
	"./brand-assets/jindo-symbol.svg": "fe51",
	"./brand-logos/uniswap-uni-logo.svg": "f6fa",
	"./collectible/files/jindocoin_wow_nft.mp4": "267b",
	"./collectible/jindocoin_wow_cover.jpg": "fe83",
	"./jindo-free-coin.png": "cfcd",
	"./jindocoin-icon.svg": "a78f",
	"./jindocoin-logotype.svg": "e601",
	"./media/bg.svg": "44b0",
	"./media/jindocoin-taxi.jpg": "88e7",
	"./media/jindocoin-to-city.jpg": "48c2",
	"./media/telegram/telegram-qr-code.jpeg": "798d",
	"./social/icons/reddit-icon.svg": "aa37",
	"./social/icons/telegram-icon.svg": "608a",
	"./social/icons/twitter-icon.svg": "3b5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";